import * as yup from 'yup'

import { IBranch } from './IBranch'
import { ALL_EMPLOYEE_ROLES, RoleEnum, RoleGroup } from './role-group'

class Employee {
  _id = ''
  firstName = ''
  lastName = ''
  email = ''
  phone = ''
  active = true
  deleted = false
  picture = ''
  notes = ''
  displayName = ''
  branchId = '' // { type: ObjectId, ref: 'Branch', index: true },
  cohort = 0 // { type: Number, enum: [0, 1, 2, 3, 4, 5, 6], default: 0 },
  color = '#f3f3f3'
  roles: RoleGroup = [] // [{ type: string = ''; enum: _.values(EmployeeRoles) }]
  ripplingId = ''
  paycomId = ''
  samsaraId = ''
  mondayId = ''
  fullName = '' // virtual
  isTeamLead = false // virtual
  isManager = false // virtual
  isSales = false // virtual
  isAdmin = false // virtual
  hasManagerialPosition = false // virtual
  branch?: IBranch // virtual
  createdAt = ''
  updatedAt = ''
}

export type RoleEmployee = (typeof RoleEnum)[keyof typeof RoleEnum]

const EmployeeValidationSchema = yup.object({
  _id: yup.string().matches(/^[a-f\d]{24}$/i, { excludeEmptyString: true }),
  firstName: yup.string().required('This field is required'),
  lastName: yup.string().required('This field is required'),
  email: yup.string().email().required('This field is required'),
  phone: yup.string(),
  active: yup.boolean(),
  deleted: yup.boolean(),
  picture: yup.string(),
  notes: yup.string(),
  paycomId: yup.string(),
  ripplingId: yup.string(),
  samsaraId: yup.string(),
  mondayId: yup.string(),
  color: yup
    .string()
    .matches(/^#\w{6}$/, 'Invalid hex color')
    .required('This field is required'),
  branchId: yup
    .string()
    .matches(/^[a-f\d]{24}$/i)
    .required('This field is required'),
  roles: yup.array().of(yup.string().oneOf(ALL_EMPLOYEE_ROLES)).min(1),
})

class EmployeeSet {
  count = 0
  page = 0
  size = 0
  total = 0
  employees: Employee[] = []
}

export interface IEmployeeOperation {
  arrive: string
  depart: string
  start: string
  end: string
  startWindowStart?: string
  startWindowEnd?: string
  earlyStart: boolean
  earlyStartNotes?: string
  lateStart?: boolean
  managerNotes?: string
  moveId?: string
  activityId?: string
}

export interface IEmployeeDayView {
  branchId: string
  branchName: string
  truckName: string
  truckId?: string
  operations: IEmployeeOperation[]
  actingManagerId?: string
  supportManagerId?: string
  arrival?: string
}
export type IEmployeeSchedule = Record<string, IEmployeeDayView>

export { Employee, EmployeeSet, EmployeeValidationSchema }
